export default __webpack_public_path__ + "static/media/fluent_open-48-filled.b810888e.svg";